import React from 'react'

const DefaultCard = () => {
  return (
    <div className="icon--default-card">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="3"
        viewBox="0 0 28 3"
        fill="none"
      >
        <path d="M28 0H0V3H28V0Z" fill="currentColor" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="3"
        viewBox="0 0 8 3"
        fill="none"
      >
        <path d="M8 0H0V3H8V0Z" fill="currentColor" />
      </svg>
    </div>
  )
}

export default DefaultCard
